var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('label', {
    staticClass: "border bg-white rounded-lg d-flex justify-content-between cursor-pointer",
    staticStyle: {
      "color": "#3f414d"
    },
    attrs: {
      "for": _vm.labelKey
    }
  }, [_c('div', {
    staticClass: "p-1 px-3 text-nowrap"
  }, [_vm.files.length ? _c('span', [_vm._v("(" + _vm._s(_vm.files.length) + ") File Selected")]) : _c('span', [_vm._v("No File Chosen")])]), _c('div', {
    staticClass: "p-1 px-2",
    staticStyle: {
      "background": "#e9ecef"
    }
  }, [_vm._v("Browse")])]), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": _vm.labelKey,
      "multiple": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }